import React from 'react';
import Shield from '../../../../assets/images/shield.svg';
import MagicWand from '../../../../assets/images/magic-wand.svg';
import { PiWarningDiamondLight } from 'react-icons/pi';
import type { OnboardingSummary } from '../../../../types/onboarding';
import useOnboardingSummary from '../../../../hooks/useOnboardingSummary';

interface SectionFourProps {
  section: OnboardingSummary;
}

const SectionFour = ({ section }: SectionFourProps) => {
  const { skillsToLearn, careerHurdles } = useOnboardingSummary({
    section,
  });

  return (
    <div>
      <div className='font-bold text-body-400 mb-4 flex items-center gap-2 mt-6'>
        <img
          className='w-6 h-6 object-contain'
          src={Shield}
          alt='Primary Goal'
        />
        Primary Goal:
      </div>
      <div className='text-lg mb-6'>Finding a mentor or career advisor</div>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img
              className='w-6 h-6 object-contain'
              src={MagicWand}
              alt='MagicWand'
            />{' '}
            Specific skills do you want to learn:
          </div>
          <div className='text-lg'>{skillsToLearn}</div>
        </div>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <PiWarningDiamondLight size={24} className='text-secondary-500' />
            Career hurdles are you trying to overcome
          </div>
          <div className='text-lg'>{careerHurdles}</div>
        </div>
      </div>
    </div>
  );
};

export default SectionFour;
